// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__NNKgw","row":"styles_row____ppz","cell":"styles_cell__TMl9D","imageRow":"styles_imageRow__zxnOy","specImage":"styles_specImage__UFNLE"};